export default __webpack_public_path__ + "static/media/Q32020.4086a744.PDF";